import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'contact/<contactId>/automation';

interface PagedResponse<T> {
	values: T[];
	pageToken?: string;
	totalCount?: number;
}

export function useContactAutomationsQuery({
	contactId,
	enabled = true,
	impersonationContext,
}: {
	contactId: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!contactId,
		queryFn: async () => {
			const response = await userSession.webServiceHelper.callAsync<PagedResponse<Api.IAutomation>>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `contact/${encodeURIComponent(contactId)}/Automation`,
					impersonationContext,
				}),
				'GET'
			);
			// API returns paginated response with values array
			return response.values || [];
		},
		queryKey: [BASE_QUERY_KEY, contactId, impersonationContext?.account?.id],
	});
}

export function invalidateAllContactAutomationsQueries() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
